export const getEnvironmentVersion = () => {
  let isPreviewValue = process.env.REACT_APP_STORYBLOK_IS_PREVIEW;
  return isPreviewValue === "yes" ? "draft" : "published";
};
